import { render, staticRenderFns } from "./IndexBottom.vue?vue&type=template&id=c7fdbb98&scoped=true&"
import script from "./IndexBottom.vue?vue&type=script&lang=js&"
export * from "./IndexBottom.vue?vue&type=script&lang=js&"
import style0 from "./IndexBottom.vue?vue&type=style&index=0&id=c7fdbb98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdbb98",
  null
  
)

export default component.exports